import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Layout from "../Layout/Layout";
import "../css/journal.css";
import JournalTable from "../Components/JournalTable";
import axios from "axios";
import { API_BASE } from "../Utils/constant";
import { useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";
import { api } from "../actions/api";

import { AUTH_TOKEN } from "../constants/localStorageKeys";
import { retrieve } from "../helpers/StorageHelper";
import JournalShareModal from "../Components/JournalShareModal";

export default function JournalLibrary() {
  const navigate = useNavigate();

  const [journals, setJournals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [types, setTypes] = useState([]);
  const [isDownloadSelected, setIsDownloadSelected] = useState(false);

  const [showJournalModal, setShowJournalModal] = useState(false);
  const [journalDetails, setJournalDetails] = useState(null);

  const [selectedIds, setSelectedIds] = useState([]);

  const [journalToDelete, setJournalToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileToShare, setFileToShare] = useState(null);
  const [titleToShare, setTitleToShare] = useState("Share you Journal");
  // const [contentToShare, setContentToShare] = useState("");
  const [journalId, setJournalId] = useState(null);

  const [pagination, setPagination] = useState({
    current_page: 1,
    total: 0,
    per_page: 10,
    last_page: 1,
  });

  const [filters, setFilters] = useState({
    emotion_name: "",
    type: "",
    sort_by: "created_at",
    sort_order: "desc",
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedJournal, setSelectedJournal] = useState(null);
  const modalRef = useRef(null);

  const searchTimeoutRef = useRef(null);

  const toggleModal = (journal = null) => {
    setSelectedJournal(journal);
    setIsModalVisible(!isModalVisible);
  };

  // settings modal
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalVisible(false);
      }
    }

    if (isModalVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isModalVisible]);

  // fetch all journals
  const fetchJournals = async () => {
    try {
      setLoading(true);
      const token = retrieve(AUTH_TOKEN);



      const response = await axios.get(`${API_BASE}/journals-library`, {
        params: {
          page: pagination.current_page,
          per_page: pagination.per_page,
          ...filters,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });



      setJournals(response.data.data.user_journals);
      setPagination(response.data.data.meta);
      setError(null);
    } catch (err) {
      console.error("Error fetching journals:", err);
      setError(err.response?.data?.message || "Failed to fetch journals");
      setJournals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJournals();
  }, [filters, pagination.current_page, pagination.per_page]);
  // store emotion name
  useEffect(() => {
    const getJournalTypes = async () => {
      try {
        const response = await api.get(`/journals/emotion-names`);

        const emotionData = response.data.data.emotion_names;
        const formatted = Object.keys(emotionData).reduce((acc, key) => {
          acc[key] = emotionData[key].map((item) => item.emotion_name);
          return acc;
        }, {});

        setTypes(formatted);

      } catch (err) {
        console.error("Error fetching journal types:", err);
        setError(
          err.response?.data?.message || "Failed to fetch journal types",
        );
      }
    };
    // const stored = retrieve("emotions");

    // if (stored) {
    //   try {
    //     const parsed = JSON.parse(stored);
    //     setEmotions(parsed);
    //   } catch (error) {
    //     console.error("Invalid JSON in localStorage for emotions:", error);
    //   }
    // }
    getJournalTypes();
  }, []);

  // filter change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setPagination((prev) => ({ ...prev, current_page: 1 }));
  };
  // pagination
  const handlePageChange = (page, perPage = pagination.per_page) => {

    setPagination((prev) => ({
      ...prev,
      current_page: page,
      per_page: perPage,
    }));
  };

  // table data
  const formatTableData = (data) => {
    if (!Array.isArray(data)) return [];


    return data.map((item) => {
      const mainQuestions = item?.journal?.main_questions || [];
      const titleQuestion = mainQuestions.find((q) => q?.keywords === "title");
      let timestamp = "";
      if (item?.is_complete) {
        timestamp = item.completed_at;
      } else {
        timestamp = item.created_at;
      }

      return {
        id: item.id,
        firstMainQuestionAnswer:
          item?.journal?.main_questions?.[0]?.answer?.text || "N/A",
        name: item?.journal?.emotion_name || "N/A",
        type: item?.journal?.type ?? "N/A",
        is_completed: item?.is_complete,
        date: timestamp
          ? new Date(timestamp).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "N/A",
        rawData: item,
      };
    });
  };

  // Add this function to handle sorting
  const handleSort = (sortField) => {
    setFilters((prev) => {
      const newOrder =
        prev.sort_by === sortField
          ? prev.sort_order === "asc"
            ? "desc"
            : "asc"
          : "asc";

      return {
        ...prev,
        sort_by: sortField,
        sort_order: newOrder,
      };
    });
  };

  // delete journal
  const handleDeleteJournal = async (journalId) => {
    try {
      const token = retrieve(AUTH_TOKEN);
      await axios.delete(`${API_BASE}/user-journals/${journalId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      fetchJournals();
      toast.success("Journal Deleted successfully!");
    } catch (err) {
      toast.error("Error deleting journal!");
      setError(err.response?.data?.message || "Failed to delete journal");
    }
  };

  //see journal modal
  const fetchJournalDetails = async (journalId) => {
    try {
      const token = retrieve(AUTH_TOKEN);
      const response = await axios.get(
        `${API_BASE}/user-journals/${journalId}/details`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setJournalDetails(response.data.data.user_journal);
      setSelectedJournalDetails([]);
      setShowJournalModal(true);
    } catch (err) {
      console.error("Error fetching journal details:", err);
      setError(
        err.response?.data?.message || "Failed to fetch journal details",
      );
    }
  };

  // Modify your row click handler
  // accept a bypass flag so callers (like the share icon) can force opening
  // the journal modal even when rows are selected
  const handleRowClick = (journal, bypass = false) => {
    if (selectedIds.length > 0 && !bypass) return;
    fetchJournalDetails(journal.id);
  };
  // modal close for see journal
  const modalRef1 = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        showJournalModal &&
        modalRef1.current &&
        !modalRef1.current.contains(event.target)
      ) {
        setShowJournalModal(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showJournalModal]);

  const handleDownloadPDF = () => {
    if (!modalRef1.current) return;

    const opt = {
      margin: [0.1, 0.1, 0.1, 0.1],
      filename: "journal-summary.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf()
      .set(opt)
      .from(modalRef1.current)
      .save()
      .then(() => {});
  };
  const [selectedJournalDetails, setSelectedJournalDetails] = useState([]);
  const [currentJournalIndex, setCurrentJournalIndex] = useState(0);

  const handleGenerateAndOpenModal = async () => {
    if (!modalRef1.current) return;

    // Set the journal ID and title based on current journal details
    if (journalDetails) {
      setJournalId(journalDetails.id);
      setTitleToShare(journalDetails.journal.emotion_name);
    }

    const clonedContent = modalRef1.current.cloneNode(true);

    const elementToRemove = clonedContent.querySelectorAll(".close-button");
    elementToRemove.forEach((el) => el.remove());

    const buttonToRemove = clonedContent.querySelector(".btn-2.btn-1-primary");
    if (buttonToRemove) {
      buttonToRemove.remove();
    }

    const style = document.createElement("style");
    style.innerHTML = `
      h5.text-white, h2, .text-body-b3{
        color: #000 !important;
      }

      .col-md-6{
        width: 100% !important;
      }

      .page-break {
        page-break-before: always; /* Forces a new page */
      }

      .no-break {
        page-break-inside: avoid; /* Prevents cutting inside this element */
      }

      .habit-sub-card{
        page-break-inside: avoid;
      }
    `;
    clonedContent.prepend(style);

    const options = {
      margin: 0.5,
      filename: "journal-report.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf()
        .from(clonedContent)
        .set(options)
        .outputPdf("blob");

      // Create a File object from the Blob
      const pdfFile = new File([pdfBlob], "journal-report.pdf", {
        type: "application/pdf",
      });
      setFileToShare(pdfFile);
      setShowJournalModal(false);
      // Open the share modal so user can choose chats/tribes to share the generated PDF
      setIsModalOpen(true);
      // intentionally removed stray expression that caused ESLint no-unused-expressions
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFileToShare(null); // Clear the file after closing the modal
    setJournalId(null); // Clear the journal ID after closing the modal
    setTitleToShare("Share you Journal"); // Reset title to default
  };

  //  multiple journals
  const fetchMultipleJournalDetails = async (journalIds) => {
    try {
      const token = retrieve(AUTH_TOKEN);
      const response = await axios.post(
        `${API_BASE}/user-journals/details`,
        {
          ids: journalIds,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSelectedJournalDetails(response.data.data.user_journals);
      setJournalDetails(null);
      setCurrentJournalIndex(0);
      setShowJournalModal(true);
    } catch (err) {
      console.error("Error fetching journal details:", err);
      setError(
        err.response?.data?.message || "Failed to fetch journal details",
      );
    }
  };

  // modal actions // delete, view, share and download
  const handleJournalAction = async (action) => {
    if (action === "delete" && selectedIds.length > 0) {
      try {
        const response = await axios.delete(`${API_BASE}/user-journals`, {
          headers: {
            Authorization: `Bearer ${retrieve(AUTH_TOKEN)}`,
          },
          data: {
            ids: selectedIds,
          },
        });

        if (response.status === 200) {
          toast.success("Journal Deleted successfully!");
          fetchJournals();
          setSelectedIds([]);
          toggleModal();
        } else {
          console.error("Failed to delete journals");
        }
      } catch (error) {
        console.error("Error deleting journals", error);
      }
    } else if (action === "view" && selectedIds.length > 0) {
      fetchMultipleJournalDetails(selectedIds);
    }

    setIsModalVisible(false);
  };

  //modal delete pop up
  const handleRequestDelete = (id) => {
    setJournalToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (journalToDelete !== null) {
      await handleDeleteJournal(journalToDelete);
      setJournalToDelete(null);
      setShowDeleteModal(false);
    }
  };

  const handleCancelDelete = () => {
    setJournalToDelete(null);
    setShowDeleteModal(false);
  };

  return (
    <Layout>
      <div className="page-content">
        <div className="journal-content journal-chat-content">
          <div
            className="d-flex align-items-center"
            style={{ flexDirection: "row", width: "max-content" }}
          >
            <img
              src="/icons/back-arrow.svg"
              alt=""
              style={{
                marginRight: "9px",
                marginBottom: "32px",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            />
            <h1 className="pages-header text-heading-h2">Journal Library</h1>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-3">
              <select
                className="text-body-b2 select-for-journal"
                name="type"
                value={filters.type}
                onChange={handleFilterChange}
                style={{
                  paddingRight: "48px",
                  width: "100%",
                  maxWidth: "236px",
                }}
              >
                <option value="">Select Emotion</option>
                {Object.entries(types).map(([type, emotions]) =>
                  emotions.map((emotion, idx) => (
                    <option key={`${type}-${idx}`} value={emotion}>
                      {emotion}
                    </option>
                  )),
                )}
              </select>

              <input
                type="text"
                className="header-search text-body-b2 input-for-journal"
                placeholder="Search by title..."
                name="emotion_name"
                value={filters.emotion_name}
                onChange={handleFilterChange}
              />
            </div>

            <div className="position-relative d-flex align-items-center">
              <img
                src="/icons/journal-linear-more.svg"
                alt="More"
                id="openModalIcon"
                style={{ cursor: "pointer", width: "24px" }}
                onClick={() => toggleModal()}
              />
              {isModalVisible && (
                <div
                  className="jurnal-library-more-option show"
                  ref={modalRef}
                  style={{ display: "block" }}
                >
                  <div className="different-options-available">
                    <div
                      className="each-option-available"
                      onClick={() => {
                        // Prevent opening share when there are selected rows
                        if (selectedIds.length === 0) {
                          handleJournalAction("share");
                        }
                      }}
                      style={{
                        cursor:
                          selectedIds.length > 0 ? "not-allowed" : "pointer",
                        opacity: selectedIds.length > 0 ? 0.5 : 1,
                      }}
                      aria-disabled={selectedIds.length > 0}
                    >
                      <img
                        src="/icons/share-image-jurnal.svg"
                        alt="Share"
                        style={{
                          filter:
                            selectedIds.length > 0 ? "grayscale(100%)" : "none",
                        }}
                      />
                      <h4
                        className="text-body-b2 mb-0"
                        style={{ color: "#ffffff" }}
                      >
                        Share
                      </h4>
                    </div>
                    <div
                      className="each-option-available"
                      onClick={() => handleJournalAction("download")}
                    >
                      <img
                        src="/icons/download-image-journal.svg"
                        alt="Download"
                      />
                      <h4
                        className="text-body-b2 mb-0"
                        style={{ color: "#ffffff" }}
                      >
                        Download
                      </h4>
                    </div>
                    <div
                      className="each-option-available"
                      onClick={() => handleJournalAction("view")}
                    >
                      <img
                        src="/icons/journal-image-journal.svg"
                        alt="See Journal"
                      />
                      <h4
                        className="text-body-b2 mb-0"
                        style={{ color: "#ffffff", cursor: "pointer" }}
                      >
                        See Journal({selectedIds.length})
                      </h4>
                    </div>
                    <div
                      className="each-option-available"
                      onClick={() => handleJournalAction("delete")}
                    >
                      <img src="/icons/journal-image-delete.svg" alt="Delete" />
                      <h4
                        className="text-body-b2 mb-0"
                        style={{ color: "#ffffff", cursor: "pointer" }}
                      >
                        Delete({selectedIds.length})
                      </h4>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              {/* <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div> */}
              <div className="loader-container">
                <div className="loader"></div>
              </div>
            </div>
          ) : (
            <JournalTable
              data={formatTableData(journals)}
              onRowClick={handleRowClick}
              pagination={pagination}
              onPageChange={handlePageChange}
              onSort={handleSort}
              // onDelete={handleDeleteJournal}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              onDeleteRequest={handleRequestDelete}
              setIsDownloadSelected={setIsDownloadSelected}
            />
          )}
        </div>
      </div>

      {/* modal for show journal- bulk show */}
      {showJournalModal && selectedJournalDetails.length > 0 && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content memory-modal"
              ref={modalRef1}
              style={{ width: "687px" }}
            >
              <button
                type="button"
                className="close-button"
                onClick={() => setShowJournalModal(false)}
                aria-label="Close"
              >
                ×
              </button>
              <div
                className="d-flex justify-content-between align-items-center p-3"
                style={{ marginTop: "3rem", paddingTop: "3rem" }}
              >
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={currentJournalIndex === 0}
                  onClick={() => setCurrentJournalIndex((prev) => prev - 1)}
                >
                  Previous
                </button>

                <span>
                  Journal {currentJournalIndex + 1} of{" "}
                  {selectedJournalDetails.length}
                </span>

                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={
                    currentJournalIndex === selectedJournalDetails.length - 1
                  }
                  onClick={() => setCurrentJournalIndex((prev) => prev + 1)}
                >
                  Next
                </button>
              </div>

              <div className="memory-modal-header">
                <div className="justify-content-center">
                  <h5 className="memory-modal-title">Journal Summary</h5>
                  <p className="memory-modal-title-second">
                    {
                      selectedJournalDetails[currentJournalIndex].journal
                        .emotion_name
                    }
                  </p>
                </div>
              </div>

              <div className="memory-modal-subtitle">
                {/* <div className="meta-info">
                  <img src="/assets/icons/discover.svg" alt="" />
                  <span>
                    {
                      selectedJournalDetails[currentJournalIndex].journal
                        .emotion_name
                    }
                  </span>
                </div> */}
                <div className="meta-info">
                  {/* <img src="/assets/icons/discover.svg" alt="" />
                  <span>{journalDetails.journal.emotion_name}</span> */}
                </div>
                <div className="meta-info">
                  <span>
                    {new Date(
                      selectedJournalDetails[currentJournalIndex]
                        .completed_at ||
                        selectedJournalDetails[currentJournalIndex].created_at,
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>
                  <img src="/assets/icons/rotate-right.svg" alt="" />
                </div>
              </div>

              <div className="memory-modal-body">
                <div className="all-modal-content">
                  <div className="story-section">
                    {selectedJournalDetails[
                      currentJournalIndex
                    ].journal_answers.map((answer, index) => (
                      <div
                        key={index}
                        className="mt-4"
                        style={{ maxWidth: "100%" }}
                      >
                        <p
                          className="questions-title"
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            overflow: "hidden",
                          }}
                        >
                          {answer.main_question?.question ||
                            answer.follow_up_question?.question}
                        </p>
                        {answer.text && (
                          <p
                            className="ans-title"
                            style={{
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap",
                              overflow: "hidden",
                            }}
                            dangerouslySetInnerHTML={{ __html: answer.text }}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="d-flex flex-column justify-content-between align-items-center gap-3">
                  <button
                    className="btn-2 btn-1-primary"
                    style={{ maxWidth: "205px", width: "100%" }}
                  >
                    Share
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* single journal details show */}
      {showJournalModal && journalDetails && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div
              className="modal-content memory-modal journal-modals-content"
              ref={modalRef1}
            >
              <button
                type="button"
                className="close-button"
                onClick={() => {
                  setShowJournalModal(false);
                  setIsDownloadSelected(false);
                }}
                aria-label="Close"
              >
                ×
              </button>

              <div className="memory-modal-header">
                <div className="justify-content-center">
                  <h5 className="memory-modal-title">Journal Summary</h5>
                  <p className="memory-modal-title-second">
                    {journalDetails.journal.emotion_name}
                  </p>
                </div>
              </div>

              <div className="memory-modal-subtitle">
                <div className="meta-info"></div>
                <div className="meta-info">
                  <span>
                    {new Date(
                      journalDetails.completed_at || journalDetails.created_at,
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>
                  <img src="/assets/icons/rotate-right.svg" alt="" />
                </div>
              </div>

              <div className="memory-modal-body">
                <div className="all-modal-content">
                  <div className="story-section">
                    {journalDetails.journal_answers
                      .filter(
                        (answer) =>
                          answer.user_journal_id === journalDetails.id,
                      )
                      .map((answer, index) => (
                        <div key={index} className="mt-4">
                          <p
                            className="questions-title"
                            style={{
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap",
                              overflow: "hidden",
                            }}
                          >
                            {answer.main_question?.question ||
                              answer.follow_up_question?.question}
                          </p>
                          {answer.text && (
                            <p
                              className="ans-title"
                              style={{
                                wordWrap: "break-word",
                                whiteSpace: "pre-wrap",
                                overflow: "hidden",
                              }}
                              dangerouslySetInnerHTML={{ __html: answer.text }}
                            />
                          )}
                        </div>
                      ))}
                  </div>
                </div>
                <div className="d-flex flex-column justify-content-between align-items-center gap-3">
                  {isDownloadSelected ? (
                    <button
                      className="btn-2 btn-1-primary"
                      style={{ maxWidth: "205px", width: "100%" }}
                      onClick={handleDownloadPDF}
                    >
                      Download
                    </button>
                  ) : (
                    <button
                      className="btn-2 btn-1-primary"
                      style={{ maxWidth: "205px", width: "100%" }}
                      onClick={handleGenerateAndOpenModal}
                    >
                      Share
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* delete  modal */}
      {showDeleteModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          aria-labelledby="notCompletedJournalModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{ backgroundColor: "#132534" }}
            >
              <div className="modal-header position-relative d-flex justify-content-center">
                <button
                  type="button"
                  className="btn-close btn-close-white position-absolute"
                  style={{
                    top: "30px",
                    right: "47px",
                    color: "#e6ecf1",
                  }}
                  onClick={handleCancelDelete}
                ></button>
                <h1
                  className="modal-title"
                  style={{ color: "#e6ecf1", fontSize: "24px" }}
                >
                  Delete Journal
                </h1>
              </div>
              <div className="modal-body">
                <p
                  className="text-body-b2 mb-4 text-center"
                  style={{ color: "#e6ecf1", fontSize: "18px" }}
                >
                  Are you sure you want to delete the journal?
                </p>

                <div
                  className="d-flex gap-3 justify-content-center"
                  style={{ marginTop: "32px" }}
                >
                  <button
                    className="btn-1 btn-1-primary px-3 text-body-b1"
                    style={{ width: "182px", background: "#db4545" }}
                    onClick={handleConfirmDelete}
                  >
                    Yes
                  </button>
                  <button
                    className="btn-1 btn-1-basic px-3 text-body-b1"
                    style={{ width: "166px" }}
                    onClick={handleCancelDelete}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <JournalShareModal
          show={isModalOpen}
          title={titleToShare}
          onClose={handleCloseModal}
          journalId={journalId}
        />
      )}
    </Layout>
  );
}
